module.exports = __webpack_public_path__ + "prod/1.42.2/img/solution_six.6be392c5.png";